<template>
  <component :is="tag" class="def-program-me">
    <slot />
  </component>
</template>

<script>
export default {
  name: 'DefProgramMe',
  props: {
    tag: {
      type: String,
      default: 'div',
    },
  },
};
</script>

<style lang="scss">
.def-program-me {
  border: 1px solid var(--color-red);
}
</style>
